// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___ccaae1042fab9652e25","cls2":"CoreXNav-cls2__fe61a6135d2d619b7671 CoreXNav-cls1___ccaae1042fab9652e25"};